import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Theme } from '../../config/theme';

import ActivitySelect from '../ActivitySelect';
import NeedsSelect from '../NeedsSelect';
import Select from '../Select';

let styles;
const CLOSE_ASSET = require('./close.svg');

export default class FindADog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
    };
    this.handleSearch = props.handleSearch.bind(
      this,
      this.props.interests,
      this.props.needs,
      this.props.district,
      this.props.breeds,
    );

    this.handleDistrict = this.props.handleDistrict.bind(this);
    this.handleSuburb = this.props.handleSuburb.bind(this);
    this.handleInterests = this.props.handleInterests.bind(this);
    this.clearInterests = this.props.clearInterests.bind(this);
    this.handleNeeds = this.props.handleNeeds.bind(this);
    this.clearNeeds = this.props.clearNeeds.bind(this);
    this.handleBreeds = this.props.handleBreeds.bind(this);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect push to="/find" />;
    }

    const selectedDistrict = this.props.appdata.localitydistrict.find(
      district => this.props.district && district.id === parseInt(this.props.district, 10),
    );

    return (
      <div
        className={css(
          styles.container,
          this.props.mobFilterVisible ? styles.container_show : null,
        )}
      >
        <div
          className={css(
            styles.select_container,
            this.props.nearestMe && styles.select_container_disabled,
          )}
        >
          <Select
            name="district"
            placeholder={this.props.nearestMe ? 'Using your location' : 'All Regions'}
            options={this.props.appdata.localitydistrict.map(district => ({
              value: district.id,
              label: district.title,
            }))}
            value={this.props.district}
            handler={this.handleDistrict}
            type="location"
            style={styles.select}
            disabled={this.props.nearestMe}
          />
        </div>
        {
          <div
            className={css(
              styles.select_container,
              this.props.nearestMe && styles.select_container_disabled,
            )}
          >
            <Select
              name="suburb"
              placeholder={this.props.nearestMe ? 'Using your location' : 'All Suburbs'}
              disabled={!this.props.district || this.props.nearestMe}
              options={
                selectedDistrict
                  ? this.props.appdata.suburb
                      .filter(suburb => selectedDistrict.id === suburb.district.id)
                      .map(suburb => ({
                        value: suburb.id,
                        label: suburb.title,
                      }))
                  : []
              }
              value={this.props.suburb}
              handler={this.handleSuburb}
              type="location"
              style={styles.select}
            />
          </div>
        }
        <div className={css(styles.select_container)}>
          <Select
            name="breed"
            placeholder="All Breeds"
            options={this.props.appdata.breed
              .filter(breed => breed.enabled)
              .map(breed => ({
                value: breed.id,
                label: breed.title,
              }))}
            value={this.props.breeds}
            handler={this.handleBreeds}
            type="breed"
            style={styles.select}
          />
        </div>
        <div className={css(styles.select_container)}>
          <ActivitySelect
            value={this.props.interests}
            handler={this.handleInterests}
            clear={this.clearInterests}
            interests={this.props.appdata.interest}
          />
        </div>
        <div className={css(styles.select_container)}>
          <NeedsSelect
            value={this.props.needs}
            handler={this.handleNeeds}
            clear={this.clearNeeds}
            needs={this.props.appdata.need}
          />
        </div>
        <button className={css(styles.submit)} onClick={this.handleSearch}>
          Find a Dog
        </button>
      </div>
    );
  }
}

FindADog.defaultProps = {
  district: null,
  suburb: null,
  breeds: null,
  interests: null,
  needs: null,
  nearestMe: false,
  handleDistrict: () => {},
  handleSuburb: () => {},
  handleBreeds: () => {},
  handleInterests: () => {},
  clearInterests: () => {},
  handleNeeds: () => {},
  clearNeeds: () => {},
  toggleMobFilter: () => {},
  mobFilterVisible: false,
};

FindADog.propTypes = {
  appdata: PropTypes.object.isRequired,
  handleSearch: PropTypes.func.isRequired,
  district: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
  suburb: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
  breeds: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
  interests: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
  needs: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
  nearestMe: PropTypes.bool,
  handleDistrict: PropTypes.func,
  handleSuburb: PropTypes.func,
  handleBreeds: PropTypes.func,
  handleInterests: PropTypes.func,
  clearInterests: PropTypes.func,
  handleNeeds: PropTypes.func,
  clearNeeds: PropTypes.func,
  mobFilterVisible: PropTypes.bool,
};

styles = StyleSheet.create({
  heading: {
    marginTop: 30,
    marginBottom: 30,
    lineHeight: 2.09,
    textAlign: 'center',
    fontSize: 28,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
  close: {
    position: 'absolute',
    top: 15,
    right: 15,
    left: 'auto',
    zIndex: 6,
    height: 20,
    width: 20,
    backgroundImage: `url('${CLOSE_ASSET}')`,
    backgroundSize: 'cover',
  },
  select: {
    position: 'absolute',
    width: '180',
    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  container: {
    position: 'relative',
    zIndex: 5,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginBottom: 27,

    [Theme.mobile_query]: {
      position: 'relative',
      top: 0,
      left: 0,
      zIndex: 5,
      width: '100%',
      padding: '10px',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      opacity: 1,
    },
  },
  container_show: {
    [Theme.mobile_query]: {
      opacity: 1,
      pointerEvents: 'initial',
    },
  },
  select_container: {
    position: 'relative',
    margin: '0 5px 10px',
    width: 180,
    height: 50,

    [Theme.mobile_query]: {
      margin: '0 5px 10px',
      width: '100%',
    },
  },
  select_container_disabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  submit: {
    width: 173,
    height: 50,
    margin: '0 5px 10px',
    textTransform: 'uppercase',
    fontSize: 15,
    fontWeight: 900,
    lineHeight: 1.73,
    letterSpacing: 2,
    textAlign: 'center',
    color: Theme.white,
    borderRadius: 5,
    border: 0,
    backgroundColor: Theme.primary,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms',

    ':hover': {
      backgroundColor: '#61c3df',
    },

    '@media screen and (max-width: 750px)': {
      width: 167,
    },

    [Theme.mobile_query]: {
      width: 'auto',
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/FindADog/index.js